module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAArUlEQVQ4jaWTawrDMAyDP48dzDeLfTP3ZNqP0dI2DzomCAE/JFsh8CcMQFKXyMw+eEJrzQDeo2Rmyt2nzVWFmUmSdQSZqdbasHHbNqrqEnvNVMysOyMMVzggQSYAMSmZTgAczSssJ5ipPiK4m3UhjiAiyEwNCWaGnQncHXe/TrC//0q9qjjXdCbuydkdEb2AJCJCgKrq0f1t07GTnmInkIQkdreWH+cOSWuXf8EHgX+btxulnsAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/walleris/images/MY_PC_16.png
// module id = 86
// module chunks = 0